import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import AuthService from "../../../class/services/AuthService";

import { WhatsappShareButton, TelegramShareButton } from "react-share";
import { WhatsappIcon, TelegramIcon } from "react-share";
import { CopyToClipboard } from "react-copy-to-clipboard";

const ModalCouponSport = ({ showModal, closeModal, couponCode, couponId }) => {
    const [animate, setAnimate] = useState(false);
    const [visible, setVisible] = useState(showModal);
    const { t } = useTranslation();
    const [copied, setCopied] = useState(false);

    useEffect(() => {
        if (showModal) {
            setVisible(true);
            setTimeout(() => setAnimate(true), 200);
        } else {
            setAnimate(false);
            setTimeout(() => setVisible(false), 300);
        }
    }, [showModal]);

    if (!visible) return null;

    const handleCopy = () => {
        setCopied(true); // Update state to indicate link is copied
        setTimeout(() => setCopied(false), 3000); // Reset copied state after 3 seconds
    };

    return (
        <>
            <div
                className={`modal fade coupon-modal ${animate ? "show" : ""}`}
                tabIndex="-1"
                role="dialog"
                style={{ display: "block" }}
            >
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h3>
                                <svg
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M3.75 6.75L4.5 6H20.25L21 6.75V10.7812H20.25C19.5769 10.7812 19.0312 11.3269 19.0312 12C19.0312 12.6731 19.5769 13.2188 20.25 13.2188H21V17.25L20.25 18L4.5 18L3.75 17.25V13.2188H4.5C5.1731 13.2188 5.71875 12.6731 5.71875 12C5.71875 11.3269 5.1731 10.7812 4.5 10.7812H3.75V6.75ZM5.25 7.5V9.38602C6.38677 9.71157 7.21875 10.7586 7.21875 12C7.21875 13.2414 6.38677 14.2884 5.25 14.614V16.5L9 16.5V7.5H5.25ZM10.5 7.5V16.5L19.5 16.5V14.614C18.3632 14.2884 17.5312 13.2414 17.5312 12C17.5312 10.7586 18.3632 9.71157 19.5 9.38602V7.5H10.5Z"
                                    ></path>
                                </svg>
                                {couponCode}
                            </h3>
                            <button
                                className="btn-close"
                                aria-label="Close"
                                onClick={closeModal}
                            ></button>
                        </div>
                        <div className="modal-body">
                            <div className="modal-body">
                                {!AuthService.getCustom("live_link") ? (
                                    <div className="alert alert-danger">
                                        <strong>{t("Error")}!</strong>{" "}
                                        {t(
                                            "Live_link_not_found._Please_contact_the_administrator.",
                                        )}
                                    </div>
                                ) : (
                                    <iframe
                                        id="modal_iframe"
                                        src={`${AuthService.getCustom("live_link")}coupon/${AuthService.getCustom("lang").toLowerCase()}/${couponId}`}
                                        frameBorder="0"
                                        allowTransparency="true"
                                        title="coupon-iframe"
                                        style={{
                                            width: "100%",
                                            height: "618px",
                                        }}
                                    ></iframe>
                                )}

                                <div className="social-share">
                                    <WhatsappShareButton
                                        url={`${AuthService.getCustom("live_link")}coupon/${AuthService.getCustom("lang").toLowerCase()}/${couponId}`}
                                    >
                                        <WhatsappIcon size={32} round={true} />
                                    </WhatsappShareButton>

                                    <TelegramShareButton
                                        url={`${AuthService.getCustom("live_link")}coupon/${AuthService.getCustom("lang").toLowerCase()}/${couponId}`}
                                    >
                                        <TelegramIcon size={32} round={true} />
                                    </TelegramShareButton>

                                    <div className="copy-link-container">
                                        {/* Hidden Input */}
                                        <input
                                            type="text"
                                            value={`${AuthService.getCustom("live_link")}coupon/${AuthService.getCustom("lang").toLowerCase()}/${couponId}`}
                                            readOnly
                                            style={{
                                                visibility: "hidden",
                                                position: "absolute",
                                            }} // Hide input
                                        />
                                        <CopyToClipboard
                                            text={`${AuthService.getCustom("live_link")}coupon/${AuthService.getCustom("lang").toLowerCase()}/${couponId}`}
                                            onCopy={handleCopy}
                                        >
                                            <button className="copy-btn">
                                                <box-icon name="copy"></box-icon>
                                                {copied
                                                    ? t("Copied!")
                                                    : t("Copy Link")}
                                            </button>
                                        </CopyToClipboard>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {visible && (
                <div
                    className={`modal-backdrop fade ${animate ? "show" : ""}`}
                    onClick={closeModal}
                ></div>
            )}
        </>
    );
};

export default ModalCouponSport;
